
export const Constants = {
    xapi_url: "https://nexttech.lrs.io/dev/xapi/",
    // xapi_login: "iutrpcs",
    // xapi_password: "pilajo",

    arc_url: "https://api.nextechar.com"  // process.env.NODE_ENV === "production" ? "https://api.nextechar.com" : "https://dev.api.nextechar.com",


}